import { get, post, put, destroy } from "./base";

const LifestyleServ = {
    index: (params) => get("/lifestyles", { params }),
    single: (id) => get(`/lifestyles/${id}`),
    getProducts: (id, params) => get(`/lifestyles/${id}/products`, { params }),
    create: (payload) => post("/lifestyles", payload),
    update: (id, payload) => put(`/lifestyles/${id}`, payload),
    remove: (id) => destroy(`/lifestyles/${id}`),
    uploadImage: (formData) => post("/upload/banner", formData),
};

export default LifestyleServ;
